import { isMobile as isMobileSelector } from 'components/Shared/responsive';
import styles from './editorialsMenu.scss';
import { getMenu } from 'views/EditorialPage/selectors';
import cn from 'classnames';
import { ButtonProps, NotifyButton } from 'components/Button';
import { useSelector } from 'react-redux';
import { EditorialMenu } from 'models/EditorialMenu';
import { PageState } from 'models/PageState';

interface MenuItemProps {
  name: string;
  url: string;
}

const getLocationPathname = ({ location }: PageState) => (location ? location.pathname : '');

const useSelected = ({ url }: Pick<MenuItemProps, 'url'>) => {
  const pathname = useSelector(getLocationPathname);
  return pathname === url;
};

const MenuItem = ({ name, url }: MenuItemProps) => {
  const isSelected = useSelected({ url });
  return (
    <div>
      <a key={name} href={url}>
        <p className={cn({ [styles.current]: isSelected })}>{name}</p>
      </a>
      <p className={styles.spacer}>{name}</p>
    </div>
  );
};

export const EditorialsMenu = () => {
  const isMobile = useSelector(isMobileSelector);
  const menu = useSelector(getMenu);

  if (isMobile) {
    return <MobileMenu menu={menu} />;
  }

  return (
    <div className={styles.menuContainer}>
      {menu.map(({ name, url }) => (
        <MenuItem name={name} url={url} key={url} />
      ))}
    </div>
  );
};

interface MobileMenuItemProps extends EditorialMenu {
  appearance: ButtonProps['appearance'];
}
export const MobileMenuItem = ({ url, ticket, appearance, name }: MobileMenuItemProps) => {
  const isSelected = useSelected({ url });

  return (
    <li className={styles.mobileMenuItem}>
      <NotifyButton
        className={cn({ [styles.current]: isSelected })}
        appearance={appearance}
        border="thin"
        invert
        href={url}
        ticket={ticket}
      >
        {name}
      </NotifyButton>
    </li>
  );
};

interface MobileMenuProps {
  menu: EditorialMenu[];
}

const MobileMenu = ({ menu }: MobileMenuProps) => {
  return (
    <div>
      <ul className={styles.mobileMenuContainer}>
        {menu.map((menuItem, i) => (
          <MobileMenuItem {...menuItem} appearance="tertiary" key={menuItem.ticket || i} />
        ))}
      </ul>
    </div>
  );
};
